// eslint-disable-next-line
export default new (class BannerModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;

    if (data.Banner && data.Banner.image) {
      model.banner = data.Banner;
    } else {
      model.banner = [];
    }

    return model;
  }
})();
